import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Box, Typography, Button, Paper, Container, Chip, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Divider } from '@mui/material';
import LandingPageImg from '../assets/LandingPage.png';
import LandingPage1Img from '../assets/img_banner_op1.png';
import { AccessTime, LocationOn, Close } from '@mui/icons-material';
import { useState } from 'react';

const CarouselBanner = ({ username = '', isEnrolled = false, nextTurma = null }) => {
  const [openModal, setOpenModal] = useState(false);

  const formatDateSafe = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('T')[0].split('-');
    const d = new Date(year, month - 1, day);
    return d.toLocaleDateString('pt-BR');
  };
  const isRemota = nextTurma?.sg_modalidade === 'R';
  const highlightColor = isRemota ? '#3366FF' : '#FFB74D';
  const highlightHover = isRemota ? '#3366FF' : '#FFA726';
  const highlightTextColor = isRemota ? '#fff' : '#000';

  const bannerItems = [
    {
      id: 1,
      image: LandingPage1Img,
      content: (
        <Container maxWidth='xl' sx={{ px: { xs: 2, md: 10 } }}>
          <Box sx={{ maxWidth: '900px' }}>
            <Typography
              variant='h4'
              sx={{
                fontWeight: 300,
                color: 'rgba(255, 255, 255, 0.9)',
                mb: 1.5,
                fontSize: { xs: '1.4rem', md: '1.8rem' },
                lineHeight: 1.2,
                letterSpacing: '0.01em',
              }}
            >
              Olá,{' '}
              <Box component="span" sx={{ color: '#fff', fontWeight: 800 }}>
                {username}
              </Box>
              !
            </Typography>
            <Typography
              variant='h2'
              sx={{
                fontWeight: 300,
                color: '#fff',
                mb: 3,
                fontSize: { xs: '2.2rem', md: '3.8rem' },
                lineHeight: 1.15,
                letterSpacing: '-0.02em',
              }}
            >
              {isEnrolled ? (
                <>
                  Continue sua jornada na
                  <br />
                  <Box component='span' sx={{ fontWeight: 800 }}>capacitação</Box>{' '}
                  <Box component='span' sx={{
                    fontWeight: 900,
                    background: 'linear-gradient(to right, #8a4fff, #00f0ff)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}>
                    imersiva
                  </Box>
                  .
                </>
              ) : (
                <>
                  Bem-vindo à Plataforma de
                  <br />
                  <Box component='span' sx={{ fontWeight: 800 }}>Capacitação</Box>{' '}
                  <Box component='span' sx={{
                    fontWeight: 900,
                    background: 'linear-gradient(to right, #8a4fff, #00f0ff)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}>
                    Imersiva
                  </Box>
                </>
              )}
            </Typography>
          </Box>
        </Container>
      ),
    },
    {
      id: 2,
      image: LandingPageImg,
      content: (
        <Container
          maxWidth='xl'
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: { xs: 2, md: 10 },
            flexDirection: { xs: 'column', md: 'row' },
            gap: 4,
          }}
        >
          <Box
            sx={{ maxWidth: '500px', textAlign: 'left', mt: { xs: 4, md: 0 } }}
          >
            <Typography
              variant='h6'
              sx={{ color: '#fff', fontWeight: 400, mb: 1, opacity: 0.9 }}
            >
              Garanta já sua vaga
            </Typography>
            <Typography
              variant='h2'
              sx={{
                color: highlightColor,
                fontWeight: 800,
                mb: 3,
                fontSize: { xs: '2.5rem', md: '4rem' },
                lineHeight: 1,
              }}
            >
              Próxima Turma
            </Typography>
            <Chip
              label='VAGAS LIMITADAS'
              sx={{
                bgcolor: 'rgba(38, 50, 56, 0.9)',
                color: '#fff',
                borderRadius: 1,
                fontWeight: 'bold',
                px: 1,
                mb: 4,
              }}
            />
            <Typography sx={{ color: '#fff', opacity: 0.8, fontSize: '0.9rem' }}>
              {nextTurma?.dt_termino_inscricao ? `Inscrições abertas até dia ${formatDateSafe(nextTurma.dt_termino_inscricao)}` : 'Inscrições abertas até dia 01/01/2026'}
            </Typography>
          </Box>

          <Paper
            elevation={10}
            sx={{
              p: 4,
              bgcolor: '#0F282D',
              color: '#fff',
              borderRadius: 4,
              maxWidth: '700px',
              width: '100%',
              position: 'relative',
              mt: { xs: 2, md: 0 },
            }}
          >
            <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
              <Chip
                label='Curso'
                variant='outlined'
                sx={{
                  color: '#fff',
                  borderColor: '#fff',
                  borderRadius: 4,
                  height: 28,
                }}
              />
              <Chip
                label={nextTurma?.sg_modalidade === 'H' ? 'Híbrido' : nextTurma?.sg_modalidade === 'R' ? 'Remota' : nextTurma?.sg_modalidade === 'C' ? 'Corporativa' : 'Remota / Híbrida'}
                sx={{
                  bgcolor: highlightColor,
                  color: highlightTextColor,
                  fontWeight: 'bold',
                  borderRadius: 4,
                  height: 28,
                }}
              />
            </Box>
            <Typography
              variant='h5'
              sx={{ fontWeight: 'bold', mb: 3, lineHeight: 1.3 }}
            >
              {nextTurma?.curso?.nm_titulo || nextTurma?.nm_descricao || 'Capacitação para Operação e Manutenção de Reatores Fischer-Tropsch'}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: nextTurma?.sg_modalidade === 'H' ? 1 : 4,
                color: '#B0BEC5',
              }}
            >
              <AccessTime fontSize='small' />
              <Typography variant='body2'>
                Data:{' '}
                <Box
                  component='span'
                  sx={{ color: highlightColor, fontWeight: 'bold' }}
                >
                  {nextTurma?.dt_inicio ? formatDateSafe(nextTurma.dt_inicio) : '06/05/2026'} {nextTurma?.dt_termino ? `a ${formatDateSafe(nextTurma.dt_termino)}` : ''}
                </Box>
              </Typography>
            </Box>

            {nextTurma?.sg_modalidade === 'H' && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: 4,
                  color: '#B0BEC5',
                }}
              >
                <LocationOn fontSize='small' />
                <Typography variant='body2'>
                  Local:{' '}
                  <Box
                    component='span'
                    sx={{ color: highlightColor, fontWeight: 'bold' }}
                  >
                    São Paulo, SP, Brasil
                  </Box>
                </Typography>
              </Box>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant='contained'
                onClick={() => setOpenModal(true)}
                sx={{
                  bgcolor: highlightColor,
                  color: highlightTextColor,
                  fontWeight: 'bold',
                  borderRadius: 2,
                  textTransform: 'none',
                  px: 4,
                  '&:hover': {
                    bgcolor: highlightHover,
                  },
                }}
              >
                Saiba mais
              </Button>
            </Box>
          </Paper>
        </Container>
      ),
    },
  ];

  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      <Carousel
        autoPlay
        infiniteLoop
        showStatus={false}
        showThumbs={false}
        interval={8000}
        showArrows={true}
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          return (
            <button
              type='button'
              onClick={onClickHandler}
              style={{
                width: isSelected ? '24px' : '10px',
                height: '10px',
                borderRadius: '5px',
                margin: '0 4px',
                border: 'none',
                backgroundColor: isSelected ? '#fff' : 'rgba(255,255,255,0.5)',
                cursor: 'pointer',
                transition: 'width 0.3s ease-in-out',
                marginBottom: '30px',
              }}
              aria-label={`Banner ${index + 1}`}
            />
          );
        }}
      >
        {bannerItems.map(item => (
          <Box
            key={item.id}
            sx={{
              position: 'relative',
              height: { xs: '25rem', md: '30rem' },
              backgroundImage: `url(${item.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center 20%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  'linear-gradient(to right, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0) 100%)',
                zIndex: 1,
              }}
            />

            <Box sx={{ zIndex: 2, width: '100%', textAlign: 'left', mt: 0 }}>
              {item.content}
            </Box>
          </Box>
        ))}
      </Carousel>

      {/* Modal Saiba Mais */}
      <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth='sm' fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold', color: '#0A2540' }}>
          Informações da Turma
          <IconButton onClick={() => setOpenModal(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ py: 3 }}>
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, color: '#0A2540', lineHeight: 1.3 }}>
            {nextTurma?.curso?.nm_titulo || nextTurma?.nm_descricao || 'Capacitação para Operação e Manutenção de Reatores Fischer-Tropsch'}
          </Typography>
          <Typography variant="body1" sx={{ color: '#6B778C', mb: 4 }}>
            {nextTurma?.curso?.nm_descricao || 'Este curso apresenta a fundamentação técnica e as atividades práticas imersivas necessárias para a capacitação em reatores Fischer-Tropsch.'}
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: '#0A2540' }}>
              <AccessTime fontSize="small" sx={{ color: '#6B778C' }} />
              <Typography variant="body2" fontWeight="bold">Período:</Typography>
              <Typography variant="body2" sx={{ color: '#6B778C' }}>
                {nextTurma?.dt_inicio ? formatDateSafe(nextTurma.dt_inicio) : '06/05/2026'} a {nextTurma?.dt_termino ? formatDateSafe(nextTurma.dt_termino) : '06/06/2026'}
              </Typography>
            </Box>

            {nextTurma?.sg_modalidade === 'H' && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: '#0A2540' }}>
                <LocationOn fontSize="small" sx={{ color: '#6B778C' }} />
                <Typography variant="body2" fontWeight="bold">Local:</Typography>
                <Typography variant="body2" sx={{ color: '#6B778C' }}>São Paulo, SP, Brasil</Typography>
              </Box>
            )}

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: '#0A2540' }}>
              <Typography variant="body2" fontWeight="bold" sx={{ ml: 4 }}>Modalidade:</Typography>
              <Chip
                label={nextTurma?.sg_modalidade === 'H' ? 'Híbrido' : nextTurma?.sg_modalidade === 'R' ? 'Remota' : nextTurma?.sg_modalidade === 'C' ? 'Corporativa' : 'Remota / Híbrida'}
                size="small"
                sx={{
                  bgcolor: nextTurma?.sg_modalidade === 'H' ? '#FFF3E0' : '#E6F0FF',
                  color: nextTurma?.sg_modalidade === 'H' ? '#E65100' : '#3366FF',
                  fontWeight: 'bold',
                }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button variant="contained" onClick={() => setOpenModal(false)} sx={{ bgcolor: '#0A2540', color: '#fff', '&:hover': { bgcolor: '#001b33' }, textTransform: 'none', px: 4 }}>
            Entendi
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CarouselBanner;
